import { render, staticRenderFns } from "./IncidentsList.vue?vue&type=template&id=192e6d9c&scoped=true&"
import script from "./IncidentsList.vue?vue&type=script&lang=js&"
export * from "./IncidentsList.vue?vue&type=script&lang=js&"
import style0 from "./IncidentsList.vue?vue&type=style&index=0&id=192e6d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192e6d9c",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QBtn,QTooltip,QIcon});
